// Module
var code = "<div id=\"page-platform\"> <md-menu></md-menu> <div class=\"platform-right\"> <router-view/> </div> </div> ";
// Exports
module.exports = code;